// extracted by mini-css-extract-plugin
export var author = "style-module--author--67650";
export var course = "style-module--course--f91a0";
export var doc = "style-module--doc--c3199";
export var extra = "style-module--extra--55edf";
export var filesList = "style-module--files-list--b6cb3";
export var filesWrap = "style-module--files-wrap--509fa";
export var gallery = "style-module--gallery--46973";
export var head = "style-module--head--c0e54";
export var infoWrap = "style-module--info-wrap--592ac";
export var mainList = "style-module--main-list--d3b7c";
export var pdf = "style-module--pdf--db2a6";
export var program = "style-module--program--75b22";
export var resultWrap = "style-module--result-wrap--5c8a2";
export var screenBtn = "style-module--screen-btn--37baf";
export var slides = "style-module--slides--f97e0";
export var slidesList = "style-module--slides-list--44f94";
export var themes = "style-module--themes--3e715";
export var themesList = "style-module--themes-list--4da7b";
export var time = "style-module--time--7f2f9";
export var xls = "style-module--xls--302b3";